import React from "react";
import ReactDOM from "react-dom";
import ReactDOMServer from "react-dom/server";
var componentRegistry = {}
var namespace = "SHV";

export default function addComponentMounter(views = {}) {
    //merge modules with regular component registry

    global.ReactComponents = global.ReactComponents || {};
    global.ReactComponents = Object.assign({}, views, componentRegistry, global.ReactComponents);

    function reactComponentMounter(componentName, domNode, props) {
        const Comp = global.ReactComponents[componentName];
        if (!Comp) {
            console.log("Cannot find a component definition with the name:", componentName);
            return;
        }
        if (typeof ReactDOM.hydrate === "function") {
            const renderOrHydrate = domNode.innerHTML.trim().length ? "hydrate" : "render";
            ReactDOM[renderOrHydrate](<Comp {...props} />, domNode);
        } else {
            ReactDOM.render(<Comp {...props} />, domNode);
        }
    }

    global.reactComponentMounter = reactComponentMounter;

    //Add DOMContentLoaded listener to init components in dom
    document.addEventListener("DOMContentLoaded", function() {
        if (global.reactComponentMounter) {
            initReactComponents();
        }
    });
}

function castFunctionPropsAndMerge(funcProps, props) {
    let propsFunctions = funcProps;
    Object.keys(propsFunctions).forEach(key => {
        let funcValue = eval(propsFunctions[key]);
        if (typeof funcValue === "function") {
            props[key] = funcValue;
        }
    });
    return props;
}

/**
 * finds [data-react-component] tags and mount component with props if its registered
 *
 * **/
function initReactComponents() {
    const componentsToMount = [];

    // collect from div setups
    const reactComponents = document.querySelectorAll("[data-react-component]");
    for (let i = 0; i < reactComponents.length; i++) {
        const elem = reactComponents[i];
        const componentName = elem.getAttribute("data-react-component");
        let props = {};

        if (elem.getAttribute("data-props")) {
            let dataProps = JSON.parse(elem.getAttribute("data-props"));
            props = dataProps;
        }

        const funcProps = elem.getAttribute("data-props-functions");
        if (funcProps) {
            props = castFunctionPropsAndMerge(JSON.parse(funcProps), props);
        }
        componentsToMount.push({
            component: componentName,
            node: elem,
            props: props
        });
        // check if we should display markup for styleguide
        const renderCoderToId = elem.getAttribute("data-code");
        if (global.stg !== undefined && global.stg.displayComponentMarkup) {
            global.stg.displayComponentMarkup(ReactDOMServer, componentName, renderCoderToId, props);
        }
    }

    // collect from script setups
    const reactComponentsSetups = document.querySelectorAll("[data-react-setup]");
    for (let j = 0; j < reactComponentsSetups.length; j++) {
        const setup = JSON.parse(reactComponentsSetups[j].innerHTML);
        const node = document.getElementById(setup.domId);
        if (!node) {
            console.log("cannot find dom element width the id: " + setup.domId);
            continue;
        }
        let props = setup.props;
        if (setup.propsFunctions) {
            props = castFunctionPropsAndMerge(setup.propsFunctions, props);
        }
        let componentName = setup.component.replace("global.ReactComponents.", "");
        componentsToMount.push({
            component: componentName,
            node: node,
            props: props
        });
    }

    //start mounting
    for (let j = 0; j < componentsToMount.length; j++) {
        let config = componentsToMount[j];
        if (global.reactComponentMounter) {
            try {
                global.reactComponentMounter(config.component, config.node, config.props);
            } catch (err) {
                console.log(config.component, err);
            }
        } else {
            console.log("cannot find react component width the name: " + config.component);
        }
    }
}
